import { storedAttributeProps } from "../html-attributes";
import { applyStyleMap } from "../shared-block-styles";

import type { CSSProperties } from "react";

/**
 * The React props that reproduce an element the fallback tier claimed.
 *
 * Shared by the canvas and the send renderer, so an element preserved from a
 * template looks the same in the composer as it does in the inbox — the split
 * between a `tiptapComponent` and an `emailRenderer` is what lets those two
 * drift, and there is nothing block-specific here to justify it.
 */
export function htmlFallbackProps(
  attrs: Record<string, unknown>,
): Record<string, unknown> {
  const props: Record<string, unknown> = storedAttributeProps(attrs);

  const style: CSSProperties = {};
  applyStyleMap(style, attrs);
  if (Object.keys(style).length > 0) props.style = style;

  return props;
}
